// transactionConfigDates — short date-range formatting for transaction cells.
//
// Split out of `transactionConfig.tsx` so the presentation cells can reuse it
// without importing back into the config module (import-cycle safety).

import React from "react";

import { EmptyValue } from "@ds/display/EmptyValue";

export function shortDate(iso?: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function dateRangeShort(from?: string | null, to?: string | null): React.ReactNode {
  if (!from) return <EmptyValue />;
  const a = shortDate(from);
  const b = to && to !== from ? shortDate(to) : null;
  return b ? `${a} – ${b}` : a;
}
